import styled from 'styled-components';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  align-self: stretch;
`;

export const DashboardNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.colors.ghostWhite};
`;

export const AccessInfoContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AccessInfoHeader = styled.button`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
`;

export const AccessInfoDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const AssigneesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const ToBeAddedHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ExistingAccessList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const AssigneeRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid ${(props) => props.theme.colors.ghostWhite};

  &:last-child {
    border-bottom: none;
  }
`;

export const AssigneeMeta = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1;
`;

export const AssigneeAvatarWrap = styled.div`
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  overflow: hidden;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  & > * {
    width: 24px !important;
    height: 24px !important;
  }
`;

export const AssigneeNameInline = styled.div`
  flex: 1;
  min-width: 0;
`;

export const AssigneeActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const RemoveAssigneeButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  color: ${(props) => props.theme.colors.neutral};

  &:hover {
    background: ${(props) => props.theme.colors.ghostWhite};
  }
`;

export const MainFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 8px;
  width: 100%;
`;
